import { Component,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {

  qnCompleted = false;
  isGame = false
  isTeacher = false
  isStart = false

  constructor(public dialogRef: MatDialogRef<ConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any) {
      if(data){
        this.isStart = this.data?.isStart == true ? true : false
        this.isTeacher = this.data?.isTeacher == true ? true : false
        this.qnCompleted = this.data?.questionCompleted == true ? true : false
        this.isGame = this.data?.game == true ? true : false
      }
     }

  close(confirm:boolean = false) {
    this.dialogRef.close(confirm)
  }

}
